<template>
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="48" height="48" rx="4" fill="#A8B50A" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.672 12.4584C14.0607 11.8472 13.0697 11.8472 12.4584 12.4584C11.8472 13.0697 11.8472 14.0607 12.4584 14.672L21.7864 24L12.4584 33.328C11.8472 33.9393 11.8472 34.9303 12.4584 35.5416C13.0697 36.1528 14.0607 36.1528 14.672 35.5416L24 26.2136L33.1183 35.3318C33.7295 35.9431 34.7206 35.9431 35.3318 35.3318C35.9431 34.7206 35.9431 33.7295 35.3318 33.1183L26.2136 24L35.3318 14.8817C35.9431 14.2705 35.9431 13.2794 35.3318 12.6682C34.7206 12.0569 33.7295 12.0569 33.1183 12.6682L24 21.7864L14.672 12.4584Z"
      fill="white"
    />
  </svg>
</template>
